(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ChangesSearch', ChangesSearch);

    ChangesSearch.$inject = ['$resource'];

    function ChangesSearch($resource) {
        var resourceUrl =  'api/_search/changes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
